import { Component, OnInit, OnDestroy, ViewEncapsulation, TemplateRef, Input } from "@angular/core";
import { Location } from '@angular/common';
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { finalize, takeUntil } from "rxjs/operators";
import { GenericResponse, GenericStatus, Page, IUserAccount } from "../../../../../shared/models";
import { HttpService, AppData, NotifyService } from "../../../../../shared/services";
import { ApiResources, DateHelper, UtilHelper } from "../../../../../shared/helpers";
import { ActivatedRoute, Params } from "@angular/router";
import { IAdmissionModel } from "../../../services/models/admission.model";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from "@angular/forms";
import { AdmissionFetchHelper, TimelineCommunicationService, PIXEL_PER_LETTER, BUFFER_WIDTH } from "../../shared/helper";
import { IVitals } from "./helpers/helper";
import { LookUpModel } from "../../../services/models/look-up.model";
import { VitalType } from "@shared/entities/vital-type.entity";

@Component({
    selector: 'progress-report-vitals',
    templateUrl: "./vitals.html",
    styleUrls: ["./vitals.css"],
    encapsulation: ViewEncapsulation.None
})
export class ProgressReportVitalsPage implements OnInit, OnDestroy {

    @Input() inputAdmissionId?: number;
    admissionId: number;
    isAdmission: boolean;
    page: Page;
    modalRef: NgbModalRef;
    loading: boolean;

    dateControl: FormControl;
    addForm: FormGroup;

    records: Array<IVitals>;
    admission: IAdmissionModel;
    imgOrigin: string;

    selected: IVitals;
    submitted: boolean;
    submitting: boolean;
    isVitalTypeloading: boolean;
    isUnitTypeloading: boolean;
    widths: { createdBy: number };
    vitalTypes: Array<VitalType>;

    unitTypes: Array<LookUpModel>;
    todayDate: Date;
    minDate = DateHelper.ngbToday;

    constructor(
        private readonly httpService: HttpService,
        private readonly modalService: NgbModal,
        private readonly notifyService: NotifyService,
        private readonly appData: AppData,
        private readonly route: ActivatedRoute,
        private readonly formBuilder: FormBuilder,
        private readonly locationService: Location,
        private readonly admissionFetchHelper: AdmissionFetchHelper,
        private readonly timelineCommunicationService: TimelineCommunicationService,
    ) {
        this.page = new Page();
        this.buildAddForm();

        this.widths = {
            createdBy: 130
        }
        this.imgOrigin = location.origin + location.pathname;
        this.records = new Array<any>();
        this.vitalTypes = new Array<VitalType>();

        this.todayDate = new Date();
    }


    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;

                    this.route.parent.paramMap
                        .subscribe((params: Params) => {
                            var id = params["params"]["id"];
                            this.inputAdmissionId = parseInt(window.atob(id));
                            this.admissionId = this.inputAdmissionId || +params["params"]["id"];
                            this.isAdmission = this.inputAdmissionId ? true : params["params"]["type"] === "a";
                            this.loading = true;
                            this.admissionFetchHelper.admissionFetch(this.admissionId, this.isAdmission, (data: IAdmissionModel) => {
                                this.admission = data;
                            });
                            this.fetch();
                        });
                } else {
                    this.page.userAccount = undefined;
                }
            });
    }

    ngOnDestroy() {

    }

    // FORM
    get form() {
        return this.addForm.controls;
    }

    private buildAddForm() {
        this.dateControl = new FormControl(DateHelper.todayInFormat, [Validators.required]);
        this.addForm = this.formBuilder.group({
            date: this.dateControl,
            vitalTypeId: [null],
            //vitalTypeValue: [null],
            //vitals: this.formBuilder.array([]),
            vitals: [null]
            //unitType: [null],
        });
    }



    get vitalsForm() {
        return this.vitalsFormArray.controls;
    }

    get vitalsFormArray() { return this.addForm.controls["vitals"] as FormArray }


    addVitalsToArray(mainItem?: VitalType, givenValue?: number) {
        return this.formBuilder.group({
            name: [mainItem.name],
            givenValue: [givenValue ? givenValue : null],
            selectedUnit: [mainItem.selectedUnit ? mainItem.selectedUnit : null],
            min: [mainItem.min],
            max: [mainItem.min]
        });
    }
    // MODEL
    openModifyModel = (content: TemplateRef<any>, record?: IVitals) => {

        if (record) {
            this.selected = record;
            this.todayDate = record.date;
            this.vitalTypes = record.vitals;
        } else {
            this.fetchVitalType();
            this.todayDate = this.todayDate;
        }
        this.openModelHelper(content);
    }

    openModelHelper = (content: TemplateRef<any>) => {
        this.modalRef = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            size: "lg",
            windowClass: "custom-modal effect-scale"
        });
    }

    onCloseModal() {
        try {
            this.modalRef.close();
            this.modalRef = undefined;
            this.selected = null;
        } catch (e) {
            // ignored;
        }
    }

    fetch = () => {
        this.loading = true;
        this.httpService
            .post<GenericResponse>(ApiResources.getURI(ApiResources.progressReportVitals.base, ApiResources.progressReportVitals.fetch),
                { admissionId: this.admissionId })
            .pipe(finalize(() => this.loading = false))
            .subscribe(
                (response: GenericResponse) => {
                    if (response.status === GenericStatus[GenericStatus.Success]) {
                        var data = response.data as Array<IVitals>;
                        data.forEach(item => {
                            item.vitals = JSON.parse(item.vitals.toString());
                        })

                        var createdByWidth = Math.max(...data.map(x => x.createdByName.length)) * PIXEL_PER_LETTER;
                        this.widths.createdBy = Math.max(createdByWidth, this.widths.createdBy) + BUFFER_WIDTH - 10;
                        this.records = data;
                    } else {
                        this.notifyService.warning(response.message);
                    }
                },
                () => {
                    this.notifyService.defaultError();
                }
            );
    }


    fetchVitalType = () => {
        this.isVitalTypeloading = true;
        this.httpService
            .post<Array<VitalType>>(ApiResources.getURI(ApiResources.vitalType.base, ApiResources.vitalType.fetch), {})
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.isVitalTypeloading = false))
            .subscribe(
                (response: Array<VitalType>) => {

                    this.vitalTypes = response;
                    this.vitalTypes.forEach((item) => {

                        item.unitArray = new Array<any>();
                        item.unitArray = item.unitType.split(",");
                    });
                },
                () => {
                    this.vitalTypes = new Array<VitalType>();
                }
            );
    }

    fetchUnitType = () => {
        this.httpService
            .post<GenericResponse>(ApiResources.getURI(ApiResources.vitalType.base, ApiResources.vitalType.fetchUnitType), {})
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.isUnitTypeloading = false))
            .subscribe(
                (response: GenericResponse) => {

                    this.unitTypes = response.data as Array<LookUpModel>;

                },
                () => {
                    this.unitTypes = new Array<LookUpModel>();
                }
            );
    }

    modify = () => {
        this.submitted = true;
        if (this.addForm.invalid) return;
        for (var i = 0; i < this.vitalTypes.length; i++) {
            if (this.vitalTypes[i].givenValue < this.vitalTypes[i].min || this.vitalTypes[i].givenValue > this.vitalTypes[i].max) {
                return this.notifyService.warningToast(`${this.vitalTypes[i].name}'s Value Should be Given Between the Shown Ranges`);
            }
        }
        this.submitting = true;
        const request = this.vitalTypes.filter((item) => { return UtilHelper.isEmpty(item.givenValue) });

        var url = this.selected
            ? ApiResources.progressReportVitals.update
            : ApiResources.progressReportVitals.insert;

        var data = this.selected
            ? {
                progressReportVitalsId: this.selected.progressReportVitalsId,
                admissionId: +this.admissionId,
                modifiedBy: this.page.userAccount.accountId,
                modifiedByName: this.page.userAccount.fullName,
                date: this.todayDate,
                vitals: JSON.stringify(request)

            }
            : {
                admissionId: +this.admissionId,
                date: this.todayDate,
                createdBy: this.page.userAccount.accountId,
                modifiedByName: this.page.userAccount.fullName,
                vitals: JSON.stringify(request)

            }
        this.submitting = true;
        this.httpService
            .post<GenericResponse>(ApiResources.getURI(ApiResources.progressReportVitals.base, url), data)
            .pipe(finalize(() => this.submitting = false))
            .subscribe(
                (response: GenericResponse) => {
                    if (response.status === GenericStatus[GenericStatus.Success]) {
                        this.fetch();
                        this.timelineCommunicationService.set(true);
                        this.onCloseModal();
                    } else {
                        this.notifyService.warning(response.message);
                    }
                },
                () => {
                    this.notifyService.defaultError();
                }
            );

    }

    delete = (item: IVitals) => {
        item.deleting = true;
        this.notifyService.confirm('Are you sure you want to delete this Vital?', () => {
            this.httpService
                .post<GenericResponse>(ApiResources.getURI(ApiResources.progressReportVitals.base, ApiResources.progressReportVitals.delete), {
                    ProgressReportVitalsId: item.progressReportVitalsId, admissionId: +this.admissionId,
                    modifiedBy: this.page.userAccount.accountId,
                    modifiedByName: this.page.userAccount.fullName
                })
                .pipe(finalize(() => item.deleting = false))
                .subscribe(
                    (response: GenericResponse) => {
                        if (response.status === GenericStatus[GenericStatus.Success]) {
                            this.fetch();
                            this.timelineCommunicationService.set(true);
                        } else {
                            this.notifyService.warning(response.message);
                        }
                    },
                    () => {
                        this.notifyService.defaultError();
                    }
                );
        }, () => {
            item.deleting = false;
        });
    }

    onBack = () => {
        this.locationService.back();
    }

}
